import { useEffect, useState } from "react";
import { WEBINAR } from "@/data/content";

function remaining() {
  const ms = Math.max(0, new Date(WEBINAR.dateISO) - Date.now());
  const s = Math.floor(ms / 1000);
  return {
    DAYS: Math.floor(s / 86400),
    HRS: Math.floor((s % 86400) / 3600),
    MIN: Math.floor((s % 3600) / 60),
    SEC: s % 60,
  };
}

export default function Countdown() {
  const [t, setT] = useState(remaining);
  useEffect(() => {
    const id = setInterval(() => setT(remaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="mt-7 flex gap-3" data-testid="countdown-timer">
      {Object.entries(t).map(([label, value]) => (
        <div key={label} className="glass-card px-4 py-3 text-center min-w-[68px]" data-testid={`countdown-${label.toLowerCase()}`}>
          <p className="text-2xl font-black text-[#D9622B] tabular-nums" style={{ fontFamily: "'Big Shoulders Display', sans-serif" }}>
            {String(value).padStart(2, "0")}
          </p>
          <p className="mt-1 font-mono text-[9px] tracking-[0.25em] text-white/35">{label}</p>
        </div>
      ))}
    </div>
  );
}
